import React, { Component } from "react";
import ContainerPage from "../_Common/ContainerPage";
import { Translate } from "../../../utils/lang/translate";
import { StoreInfo, Paymenntinfo } from "./StoreInfo";
import { UserInfo } from "./User.info";
import { LoginInfo } from "./Login.info";
import { ShopContainer } from "./Shop";
import { IntegrationsPage } from "./IntegrationsPage";
import { TeamPage } from "./StoreTeam/TeamPage";
import { SubscriptionPage } from "./SubscriptionPage";
import { Switch, Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import StoreSettingsForm from "./Shop/StoreSettingsForm";
import ThemeSettingsForm from "./Shop/ThemeSettingsForm";
import SubdomainSettingsForm from "./Shop/SubdomainSettingsForm";
import FacebookSettingsForm from "./Shop/FacebookSettingsForm";
import FinishSettingShop from "./Shop/FinishSettingShop";
import ShopPublishedSuccess from "./Shop/ShopPublishedSuccess";
import { checkUserHasShopPermissionById } from "../../../utils/helpers";
class SettingsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    document.title = "Maystro Delivery - " + Translate("titles", "settings");
  }
  render() {
    const { dtStoreinfo } = this.props;
    return (
      <ContainerPage page_title={Translate("titles", "settings")}>
        {/*<UnderDevPage/>*/}
        <div className="InFlx flxDrc responsFlx FlWd JstfCnt">
          <div className="StVl2dt ">
            <Switch>
              <Route path="/settings/store/payement" component={Paymenntinfo} />
              <Route path="/settings/store" component={StoreInfo} />
              <Route path="/settings/user" component={UserInfo} />
              <Route path="/settings/security" component={LoginInfo} />
              <Route
                path="/settings/integration"
                component={IntegrationsPage}
              />
              <Route path="/settings/team" component={TeamPage} />
              <Route
                path="/settings/subscription"
                component={SubscriptionPage}
              />
              {dtStoreinfo?.id &&
                checkUserHasShopPermissionById(dtStoreinfo.id) && (
                  <Route
                    path="/settings/shop/store"
                    exact
                    render={(props) => (
                      <ShopContainer {...props}>
                        <StoreSettingsForm />
                      </ShopContainer>
                    )}
                  />
                )}
              {dtStoreinfo?.id &&
                checkUserHasShopPermissionById(dtStoreinfo.id) && (
                  <Route
                    path="/settings/shop/theme"
                    exact
                    render={(props) => (
                      <ShopContainer {...props}>
                        <ThemeSettingsForm />
                      </ShopContainer>
                    )}
                  />
                )}
              {dtStoreinfo?.id &&
                checkUserHasShopPermissionById(dtStoreinfo.id) && (
                  <Route
                    path="/settings/shop/domain"
                    exact
                    render={(props) => (
                      <ShopContainer {...props}>
                        <SubdomainSettingsForm />
                      </ShopContainer>
                    )}
                  />
                )}
              {dtStoreinfo?.id &&
                checkUserHasShopPermissionById(dtStoreinfo.id) && (
                  <Route
                    path="/settings/shop/facebook"
                    exact
                    render={(props) => (
                      <ShopContainer {...props}>
                        <FacebookSettingsForm />
                      </ShopContainer>
                    )}
                  />
                )}
              {dtStoreinfo?.id &&
                checkUserHasShopPermissionById(dtStoreinfo.id) && (
                  <Route
                    path="/settings/shop/finish"
                    exact
                    render={(props) => (
                      <ShopContainer {...props}>
                        <FinishSettingShop />
                      </ShopContainer>
                    )}
                  />
                )}

              {dtStoreinfo?.id &&
                checkUserHasShopPermissionById(dtStoreinfo.id) && (
                  <Route
                    path="/settings/shop/success"
                    exact
                    render={(props) => <ShopPublishedSuccess {...props} />}
                  />
                )}

              {dtStoreinfo?.id &&
                checkUserHasShopPermissionById(dtStoreinfo.id) && (
                  <Redirect from="/settings/shop/*" to="/settings/shop/store" />
                )}
              <Redirect from="*" to="/settings/user" />
            </Switch>
          </div>
        </div>
      </ContainerPage>
    );
    /* */
    //<UnderDevPage/>
  }
}

function mapState(state) {
  const { dtStoreinfo } = state.user;
  return {
    dtStoreinfo,
  };
}

const connectedSettingsPage = connect(mapState, {})(SettingsPage);
export { connectedSettingsPage as SettingsPage };
